import { createFileRoute } from '@tanstack/react-router';
import { MaterialModal } from 'src/components/creator/MaterialModal';

const EditMaterialRoute = () => {
  const { id } = Route.useParams();

  return <MaterialModal materialId={id} />;
};

export const Route = createFileRoute(
  '/_authenticated/_creator/materials/$id/edit'
)({
  component: EditMaterialRoute,
});
